module.exports = __webpack_public_path__ + "img/3.55c1c137.jpg";